import React, { useState } from "react";
import { Formik, Form } from "formik";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Input, Button, Modal } from "components/bootstrap";
import BootstrapModalWrapper from "components/bootstrap/BootstrapModalWrapper";
import ModalSubmit from "components/common/ModalSubmit";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { ForwardersActions } from "../stores/ForwardersStore";
const StyledButton = styled(Button)`
  vertical-align: top;
`;
const ForwarderForm = ({ forwarder, buttonBsStyle = "info", buttonBsSize = null, onSave = () => {
} }) => {
  const { t } = useTranslation("enterprise_forwarder");
  const [showModal, setShowModal] = useState(false);
  const sendTelemetry = useSendTelemetry("input-profile");
  const _openModal = () => setShowModal(true);
  const _closeModal = () => setShowModal(false);
  const _updateForwarder = (title = forwarder.title, description = forwarder.description, inputProfileId = forwarder.input_profile_id) => {
    const updatedForwarder = {
      input_profile_id: inputProfileId,
      title,
      description,
      hostname: forwarder.hostname
    };
    ForwardersActions.update(forwarder.id, updatedForwarder).then(() => {
      sendTelemetry(TELEMETRY_EVENT_TYPE.FORWARDER.FORWARDER_UPDATED, {
        app_pathname: "forwarder"
      });
    });
  };
  const handleSubmit = (values) => {
    _updateForwarder(values.title, values.description, forwarder.input_profile_id);
    onSave();
    _closeModal();
  };
  const modalTitle = t("forwarder_form.modal_title");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledButton, { bsStyle: buttonBsStyle, bsSize: buttonBsSize, onClick: _openModal }, t("forwarder_form.edit")), /* @__PURE__ */ React.createElement(BootstrapModalWrapper, { showModal, onHide: _closeModal, bsSize: "lg" }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, modalTitle)), /* @__PURE__ */ React.createElement(
    Formik,
    {
      initialValues: { title: forwarder.title, description: forwarder.description, hostname: forwarder.hostname },
      onSubmit: handleSubmit
    },
    ({ values, handleChange, isSubmitting }) => /* @__PURE__ */ React.createElement(Form, null, /* @__PURE__ */ React.createElement(Modal.Body, null, /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "title",
        name: "title",
        label: t("forwarder_form.title_label"),
        type: "text",
        value: values.title,
        onChange: handleChange,
        help: t("forwarder_form.title_help"),
        required: true
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "description",
        name: "description",
        label: t("forwarder_form.description_label"),
        type: "text",
        value: values.description,
        onChange: handleChange,
        help: t("forwarder_form.description_help")
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "hostname",
        name: "hostname",
        label: t("forwarder_form.hostname_label"),
        type: "text",
        disabled: true,
        value: values.hostname,
        onChange: handleChange,
        help: t("forwarder_form.hostname_help")
      }
    )), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
      ModalSubmit,
      {
        onCancel: _closeModal,
        isSubmitting,
        isAsyncSubmit: true,
        submitButtonText: t("forwarder_form.modal_title"),
        submitLoadingText: t("forwarder_form.updating")
      }
    )))
  )));
};
export default ForwarderForm;
